import L from 'leaflet';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames/bind';
import autosize from 'autosize';
import Mousetrap from 'mousetrap';
import intl from 'react-intl-universal';

import Button from '../../../../../../components/Button/index';
import './EditModal.css';


@observer
class EditModal extends Component {
    componentDidMount = (e) => {
        autosize(this.textarea);
        Mousetrap.bind(['enter'], this.handleSave);
        L.DomEvent.disableClickPropagation(this.wrapperDOMref);
    };
    componentWillUnmount = () => {
        Mousetrap.unbind(['enter'], this.handleSave);
    };
    handleTextChange = (e) => {
        this.props.appStore.setPendingElementText(e.target.value);
    };
    handleReactionChange = (reaction) => {
        if (reaction === this.props.appStore.pendingState.element.reaction) {
            this.props.appStore.setPendingElementReaction('none');
        } else {
            this.props.appStore.setPendingElementReaction(reaction);
        }
    };
    handleDelete = () => {
        this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        this.props.appStore.clearPending();
    };
    handleCancel = () => {
        if (!this.props.appStore.pendingState.editing) {
            this.props.appStore.elementStore.removeElement(this.props.appStore.pendingState.element.uuid);
        }
        this.props.appStore.clearPending();
    };
    handleSave = () => {
        if (this.props.appStore.elementStore.inStore(this.props.appStore.pendingState.element)) {
            this.props.appStore.elementStore.updateElement(this.props.appStore.pendingState.element.uuid, this.props.appStore.pendingState.element);
        } else {
            this.props.appStore.elementStore.addElement(this.props.appStore.pendingState.element);
        }
        this.props.appStore.clearPending();
    };

    getReactionContainerStatus = (icon) => {
        console.log('getReactionContainerStatus: ' + icon.toString());
        if (icon && icon.reactionContainer === false) return;
        return (<div className="reactionContainer">
            <Button onClick={(e) => this.handleReactionChange('approve')}
                    className={classNames({
                        'active': (this.props.appStore.pendingState.element && this.props.appStore.pendingState.element.reaction === 'approve'),
                        'approve': true
                    })}>
                <i className="fa fa-thumbs-up" aria-hidden="true"/>
            </Button>
            <Button onClick={(e) => this.handleReactionChange('disapprove')}
                    className={classNames({
                        'active': (this.props.appStore.pendingState.element && this.props.appStore.pendingState.element.reaction === 'disapprove'),
                        'disapprove': true
                    })}>
                <i className="fa fa-thumbs-down" aria-hidden="true"/>
            </Button>
        </div>);
    };

    getReactionTitle = (elementTypeText, icon) => {
        if (icon && icon.reactionContainer === false) return;
        return (
            <p>{this.props.appStore.pendingState.editing ? intl.get("EditModal.reactionTitle", {icon_type: elementTypeText}) : intl.get("EditModal.reactionTitle", {icon_type: elementTypeText})}</p>);
    };

    render() {
        if (!this.props.appStore.pendingState.element) {
            return (null);
        }
        let elementTypeText = intl.get(this.props.appStore.pendingState.element.icon.type);
        return (
            <div className="EditModal" ref={ref => this.wrapperDOMref = ref}>
                <div>
                    <h4>{this.props.appStore.pendingState.editing ? intl.get("EditModal.editTitle", {icon_type: elementTypeText}) : intl.get("EditModal.addTitle", {icon_type: elementTypeText})}</h4>
                    {this.getReactionTitle(elementTypeText, this.props.appStore.pendingState.element.icon)}
                    {this.getReactionContainerStatus(this.props.appStore.pendingState.element.icon)}

                    <p>{this.props.appStore.pendingState.editing ? intl.get("EditModal.commentTitle", {icon_type: elementTypeText}) : intl.get("EditModal.commentTitle", {icon_type: elementTypeText})}</p>
                    <textarea ref={c => this.textarea = c} onChange={this.handleTextChange}
                              value={this.props.appStore.pendingState.element.text} rows={2}
                              placeholder={intl.get("EditModal.textarea_placeholder")}/>

                    <div className="buttons">
                        {this.props.appStore.pendingState.editing &&
                        <button className="delete" onClick={this.handleDelete}>
                            {intl.get("EditModal.delete")}
                        </button>
                        }

                        <button className="cancel" onClick={this.handleCancel}>
                            {intl.get("EditModal.cancel")}
                        </button>

                        <button className="save" onClick={this.handleSave}>
                            {intl.get("EditModal.save")}
                        </button>


                    </div>
                </div>
            </div>
        );
    }
}

export default EditModal;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PopupContainer/components/EditModal/index.js